"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StubTokenGenerator {
    generate() {
        return Promise.reject(new Error('Tokens can only be generated in a Node.js environment'));
    }
}
exports.default = StubTokenGenerator;
